var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "sidebar-layout" },
    [
      _c(
        "b-sidebar",
        {
          staticClass: "secondary-sidebar",
          attrs: {
            mobile: "fullwidth",
            position: "static",
            type: "is-light",
            open: _vm.shouldSidebarBeOpen,
          },
        },
        [
          _c("div", { staticClass: "p-1" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c(
                  "b-menu",
                  { staticClass: "is-custom-mobile" },
                  [
                    _c(
                      "b-menu-list",
                      _vm._l(_vm.options, function (option, i) {
                        return _c(
                          "b-menu-item",
                          {
                            key: `${option}-${i}`,
                            attrs: {
                              id: `${option.id}-tab`,
                              label: option.label,
                              icon: option.icon,
                              value: option.label,
                              active:
                                _vm.sectionActive == i &&
                                _vm.screenWidth >= 768 &&
                                _vm.openSidebar,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleClick(i)
                              },
                            },
                          },
                          [
                            option.submenu && option.submenu.length > 0
                              ? _c(
                                  "div",
                                  _vm._l(
                                    option.submenu,
                                    function (subOption, j) {
                                      return _c("b-menu-item", {
                                        key: `${subOption}-${j}`,
                                        attrs: {
                                          id: `${subOption.id}-sub-tab`,
                                          label: subOption.title,
                                          disabled: j > 0,
                                          active: j === 0,
                                          value: subOption.title,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }